import { UserApi } from 'api-typings/users/users';
import { User } from './users.model';

export function transformUser(user: UserApi): User {
  if (
    !user.id ||
    !user.username ||
    !user.avatar ||
    !user.avatar_large ||
    !user.role
  ) {
    throw new ReferenceError(`Missing a required user field.`);
  }

  const displayName: string =
    user.support_status && user.support_status.short_name
      ? user.support_status.short_name
      : user.public_name || user.display_name || user.username;
  return {
    id: user.id,
    avatar: transformUserImage(user.avatar),
    avatarLarge: transformUserImage(user.avatar_large),
    supportStatus: user.support_status
      ? {
          type: user.support_status.type,
          shortName: user.support_status.short_name,
        }
      : undefined,
    username: user.username,
    displayName,
    role: user.role,
    profileUrl: `/u/${user.username}`,
  };
}

export function transformUserImage(image: string): string | undefined {
  return image !== '/img/unknown.png' ? image : undefined;
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/users/users.transformers.ts